import { Text } from "@mantine/core";

import { useStyles } from "./AIResult.styles.ts";
import { AIResult as AIResultType } from "./types.ts";

interface Props {
  result: AIResultType;
}

export const AIResult = ({ result }: Props) => {
  const { classes } = useStyles();

  return (
    <div className={classes.resultWrapper}>
      {result.map((block, index) => {
        return (
          <Text
            key={index}
            dangerouslySetInnerHTML={{
              __html: block.text,
            }}
          />
        );
      })}
    </div>
  );
};
